import { TextField } from './types';

const textFieldTheme: TextField = {
	aspectSize: {
		xs: {
			label: {
				offset: 8
			}
		},
		s: {
			label: {
				offset: 8
			}
		},
		m: {
			label: {
				offset: 10
			}
		},
		l: {
			label: {
				offset: 12
			}
		}
	}
};

export default textFieldTheme;
